<template>
  <div class="address">
    <h2 class="tit-30 fw700">我的收货地址</h2>

    <!-- 地址列表 -->
    <div
      class="address-card"
      v-for="(item, index) in sortedAddressList"
      :key="item.id"
    >
      <div class="address-info">
        <div class="default tit-14 cor-fff" v-if="item.moren == 1">默认</div>
        <div class="tle">
          <span class="name fw700">{{ item.ming }}</span>
          <span class="tel">{{ item.dianhua }}</span>
        </div>
      </div>

      <div class="operate-group">
        <div class="address flex">
          <div v-for="(item2, index) in item.shengshiqu" :key="index">
            {{ item2 }}
          </div>
          <div>{{ item.dizhi }}</div>
        </div>

        <div class="btn">
          <div class="edit" @click="handleEdit(index)">
            <i class="el-icon-edit-outline tit-18"></i>
            <span class="tit-14 ml-10">修改</span>
          </div>
          <div class="delete" @click="handleDelete(index)">
            <i class="el-icon-delete tit-18"></i>
            <span class="tit-14 ml-10">删除</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <!-- <div v-if="addressList.length === 0" class="empty-state">
      <el-empty description="暂无收货地址"></el-empty>
    </div> -->

    <!-- 添加新地址按钮 -->
    <div class="add-address flex-cc" @click="handleAdd">
      <i class="el-icon-circle-plus-outline tit-24"></i>
      <span class="ml-10">添加新地址</span>
    </div>

    <!-- 新增/编辑地址弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      title="收货地址"
      class="addressDialog"
    >
      <el-form
        :model="formData"
        :rules="rules"
        ref="formRef"
        label-width="80px"
      >
        <el-form-item label="姓名" prop="ming">
          <el-input v-model="formData.ming" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="dianhua">
          <el-input v-model="formData.dianhua" placeholder="手机号"></el-input>
        </el-form-item>

        <el-form-item
          label="所在地区"
          prop="shengshiqu"
          class="mobile-cascader-item"
        >
          <el-cascader
            v-if="isPc"
            v-model="formData.shengshiqu"
            :options="optionsnative_place"
            placeholder="省份 | 城市 | 区县"
          />

          <!-- 移动端：Vant 级联选择器（底部弹出，适配移动端） -->
          <div v-else class="vant-cascader-wrap">
            <!-- 显示已选值的输入框（只读） -->
            <el-input
              v-model="addressText"
              placeholder="省份 | 城市 | 区县"
              readonly
              @click.native="showVantCascader = true"
            />
            <!-- Vant 弹窗 + 级联选择器 -->
            <van-popup
              v-model="showVantCascader"
              position="bottom"
              round
              class="vant-cascader-popup"
            >
              <van-cascader
                v-model="vantCascaderValue"
                :options="vantAreaOptions"
                :field-names="{
                  text: 'text',
                  value: 'value',
                  children: 'children',
                }"
                :columns-num="3"
                @close="onVantCascaderClose"
                @finish="onVantCascaderFinish"
                title="选择省市区"
              />
            </van-popup>
          </div>
        </el-form-item>

        <el-form-item label="详细地址" prop="dizhi">
          <el-input
            type="textarea"
            v-model="formData.dizhi"
            rows="3"
          ></el-input>
        </el-form-item>
        <el-form-item label="设为默认">
          <el-checkbox v-model="formData.moren">默认地址</el-checkbox>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
// 引入省市区
import {
  provinceAndCityData, //省市二级联动数据,汉字+code
  pcTextArr, // 省市区三级联动数据
  regionData, // 省市联动数据，纯汉字
  pcaTextArr, //省市区联动数据，纯汉字
  codeToText, // 是个大对象，属性是区域码，属性值是汉字 用法例如：codeToText[‘110000’]输出北京市
} from "element-china-area-data";

// 导入Vant组件
import { Cascader, Popup } from "vant";

const optionsnative_place = pcaTextArr;

console.log(optionsnative_place);

export default {
  name: "addressIndex",

  components: {
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
  },

  data() {
    return {
      isPc: true, // 是否为PC端
      showVantCascader: false, // 移动端选择器弹窗显示状态
      vantCascaderValue: "", // Vant级联选择器绑定值（字符串类型）
      addressText: "", // 移动端显示的地址文本
      vantAreaOptions: [], // Vant组件专用的省市区数据

      optionsnative_place, // 省市区
      // 地址列表数据
      addressList: [],
      // 弹窗状态
      dialogVisible: false,
      // 表单数据
      formData: {
        id: null,
        ming: "",
        dianhua: "",
        dizhi: "",
        shengshiqu: [],
        moren: false,
      },
      // 表单验证规则
      rules: {
        ming: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        dianhua: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        shengshiqu: [
          { required: true, message: "请选择省市区", trigger: "blur" },
        ],
        dizhi: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
      },
      // 当前操作类型：add 或 edit
      currentAction: "add",
    };
  },
  created() {
    this.CSH();
    // 判断设备类型
    this.judgeDevice();
    // 转换数据格式适配vant组件
    this.vantAreaOptions = this.transformAreaData(this.optionsnative_place);
  },
  computed: {
    // 计算属性：默认地址排在最前面
    sortedAddressList() {
      return [...this.addressList].sort((a, b) => {
        if (a.moren && !b.moren) return -1;
        if (!a.moren && b.moren) return 1;
        return 0;
      });
    },
  },
  methods: {
    // 判断设备类型（PC/移动端）
    judgeDevice() {
      const userAgent = navigator.userAgent;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent,
      );
      this.isPc = !isMobile;
    },

    // 转换省市区数据格式适配vant组件
    transformAreaData(data) {
      if (!data || !Array.isArray(data)) return [];
      return data.map((item) => {
        // 确保每个节点都有完整的结构
        const transformedItem = {
          text: item.label || item.name || item.text || "",
          value: item.value || item.code || item.id || "",
          children: item.children ? this.transformAreaData(item.children) : [],
        };

        // 如果children为空数组，删除children属性（避免vant组件显示异常）
        if (transformedItem.children && transformedItem.children.length === 0) {
          delete transformedItem.children;
        }

        return transformedItem;
      });
    },

    // 更新地址显示文本
    updateAddressText(value) {
      if (!value || !value.length) {
        this.addressText = "";
        return;
      }

      if (value.length >= 3) {
        this.addressText = `${value[0]} ${value[1]} ${value[2]}`;
      } else {
        this.addressText = value.join(" ");
      }
    },

    // 获取我的地址
    CSH: function() {
      var that = this;
      that.$post("k=dizhi", function(shu) {
        if (shu.shi == 1) {
          that.addressList = shu.shu;
        }
      });
    },
    // 处理添加新地址
    handleAdd() {
      this.currentAction = "add";
      // 重置表单数据
      this.formData = {
        ming: "",
        dianhua: "",
        dizhi: "",
        shengshiqu: [],
        moren: 0,
      };
      // 重置移动端选择器状态
      this.vantCascaderValue = "";
      this.addressText = "";
      this.dialogVisible = true;
    },

    // 处理编辑地址
    handleEdit(index) {
      this.currentAction = "edit";
      const sortedId = this.sortedAddressList[index].id;
      const originalIndex = this.addressList.findIndex(
        (item) => item.id === sortedId,
      );
      const targetAddress = this.addressList[originalIndex];

      this.formData = JSON.parse(JSON.stringify(targetAddress));
      this.formData.moren = this.formData.moren == 1;

      // --- 1. 处理后端返回的字符串格式省市区 ---
      if (
        targetAddress.shengshiqu &&
        typeof targetAddress.shengshiqu === "string"
      ) {
        // 把字符串按空格拆分成数组
        const textList = targetAddress.shengshiqu.split(" ").filter(Boolean);
        this.updateAddressText(textList); // 同步移动端显示文本

        // --- 2. 递归查找文本对应的 value 数组 ---
        const findValueByText = (textList, options) => {
          let result = [];
          let currentOptions = options;
          for (let i = 0; i < textList.length; i++) {
            const match = currentOptions.find(
              (item) => item.label === textList[i],
            );
            if (match) {
              result.push(match.value);
              currentOptions = match.children || [];
            } else {
              console.warn("未找到匹配的省市区:", textList[i]);
              break;
            }
          }
          return result;
        };

        // 赋值给 formData.shengshiqu，让 el-cascader 可以回显
        this.formData.shengshiqu = findValueByText(
          textList,
          this.optionsnative_place,
        );
        // 同步 Vant 组件需要的 value（最后一级的 value）
        this.vantCascaderValue =
          this.formData.shengshiqu[this.formData.shengshiqu.length - 1] || "";
      } else {
        this.formData.shengshiqu = [];
        this.vantCascaderValue = "";
        this.addressText = "";
      }

      this.dialogVisible = true;
    },

    // 处理删除地址
    handleDelete(index) {
      var that = this;
      const address = that.addressList[index];
      // 不能删除唯一的默认地址
      if (address.moren && that.addressList.length === 1) {
        that.$message.warning("不能删除唯一的默认地址");
        return;
      }

      that
        .$confirm("此操作将永久删除该地址, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$post(
            "k=dizhi&c=shandiao",
            { id: that.addressList[index].id },
            function(shu) {
              if (shu.shi == 1) {
                that.CSH();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            },
          );
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // Vant级联选择器关闭事件
    onVantCascaderClose() {
      this.showVantCascader = false;
    },

    // Vant级联选择器完成选择事件
    onVantCascaderFinish({ selectedOptions }) {
      if (selectedOptions && selectedOptions.length > 0) {
        // 获取选中的值数组
        const value = selectedOptions.map((item) => item.text);
        // 获取显示的文本
        const text = selectedOptions.map((item) => item.text).join(" ");
        // 获取Vant组件的值（最后一个选中项的value）
        const vantValue = selectedOptions[selectedOptions.length - 1].value;

        this.formData.shengshiqu = value;
        this.vantCascaderValue = vantValue;
        this.addressText = text;

        console.log("Vant选择器完成选择:", { value, text, vantValue });
        this.showVantCascader = false;

        // 触发验证
        this.$nextTick(() => {
          this.$refs.formRef.validateField("shengshiqu");
        });
      }
    },

    // 提交表单
    submitForm() {
      var that = this;
      that.$refs.formRef.validate((valid) => {
        if (valid) {
          let submitData = { ...that.formData };

          if (
            that.formData.shengshiqu &&
            Array.isArray(that.formData.shengshiqu) &&
            that.formData.shengshiqu.length > 0
          ) {
            // 直接用文本数组拼接成字符串，不需要 codeToText
            submitData.shengshiqu = that.formData.shengshiqu.join(" ");

            console.log(submitData.shengshiqu, "111");
          } else {
            submitData.shengshiqu = "";
          }

          // 如果设为默认地址，先将其他地址设为非默认
          if (that.formData.moren) {
            that.addressList.forEach((item) => {
              item.moren = false;
            });
          }

          that.$post("k=dizhi&c=xinzeng", submitData, function(s) {
            if (s.shi == 1) {
              if (that.currentAction === "add") {
                // 添加新地址
                that.$message.success("添加成功");
              } else {
                that.$message.success("修改成功");
              }
            }
            that.CSH();
          });
          that.dialogVisible = false;
        } else {
          that.$message.error("表单验证失败，请检查输入");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.address {
  h2 {
    padding-bottom: 0.2rem;
  }
  .address-card {
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 0.13rem;
    overflow: hidden;
    position: relative;
    padding: 0.4rem;
    min-height: 1.45rem;
    margin-top: 0.2rem;

    .address-info {
      .default {
        position: absolute;
        right: 0;
        top: 0;
        background: linear-gradient(-49deg, #41b9e0 0%, #001ff5 100%);
        border-radius: 0rem 0rem 0rem 0.15rem;
        text-align: center;
        padding: 0.04rem 0.14rem;
      }

      .name {
        margin-right: 0.6rem;
      }
    }

    .operate-group {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 0.1rem;
      .address {
        color: #a1a1a1;
      }

      .btn {
        display: flex;
        > div {
          color: #959595;
          display: flex;
          align-items: center;
          cursor: pointer;

          &:hover {
            color: #001ff5;
          }
        }
        .edit {
          margin-right: 0.6rem;
        }
      }
    }
  }
  .add-address {
    margin-top: 1rem;
    cursor: pointer;
  }
}

/deep/ .addressDialog {
  .el-cascader {
    width: 100%;
  }
}

@media screen and (max-width: 767px) {
  .address {
    .address-card {
      .address-info {
        width: 100%;
      }
      .operate-group {
        width: 100%;

        .btn {
          margin-top: 0.2rem;
          width: 100%;
          justify-content: flex-end;
        }
      }
    }
  }

  /deep/ .addressDialog .el-dialog {
    width: 94% !important;
  }
}
</style>
